const AboutUs = () => {
  return <h1>I am About Us Page</h1>;
};
export default AboutUs;
